import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const GOLD = '#B8892A';
const INK = '#1A1410';
const INK3 = '#6B5840';
const BG = '#FAF8F5';

const S = {
  page: { minHeight: '100vh', background: BG, paddingBottom: 60 },
  header: {
    position: 'sticky', top: 0, zIndex: 10, background: '#fff',
    borderBottom: '1px solid #EAE5DC', display: 'flex', alignItems: 'center',
    padding: '12px 16px', gap: 12,
  },
  back: {
    border: 'none', background: 'none', fontSize: 20, cursor: 'pointer',
    color: INK, padding: 0, lineHeight: 1,
  },
  title: { fontSize: 16, fontWeight: 600, color: INK },
  body: { padding: '20px 16px', maxWidth: 640, margin: '0 auto' },
  section: { marginBottom: 28 },
  h1: { fontSize: 18, fontWeight: 700, color: GOLD, marginBottom: 16 },
  h2: { fontSize: 15, fontWeight: 600, color: INK, marginBottom: 10, marginTop: 20 },
  p: { fontSize: 13, color: INK3, lineHeight: 1.8, marginBottom: 6 },
  ul: { fontSize: 13, color: INK3, lineHeight: 1.8, paddingLeft: 20, marginBottom: 6 },
  divider: { height: 1, background: '#EAE5DC', margin: '24px 0' },
};

export default function HelpFaq() {
  const navigate = useNavigate();
  const location = useLocation();
  const handleBack = () => {
    if (location.state?.from) navigate(location.state.from);
    else navigate(-1);
  };
  return (
    <div style={S.page}>
      <div style={S.header}>
        <button style={S.back} onClick={handleBack}>&larr;</button>
        <span style={S.title}>常见问题</span>
      </div>
      <div style={S.body}>
        <div style={S.section}>
          <h2 style={S.h1}>三、常见问题</h2>

          <h3 style={S.h2}>1. 费用说明</h3>
          <p style={S.p}>云川中古坚持费用透明。</p>
          <p style={S.p}>页面显示金额已包含：</p>
          <ul style={S.ul}>
            <li>日本消费税</li>
            <li>拍卖会手续费</li>
          </ul>
          <p style={S.p}>除明确标注的固定服务费外，本平台不收取任何隐形费用。</p>
          <p style={S.p}>固定服务费如下：</p>
          <ul style={S.ul}>
            <li>中拍成功：代拍服务费200元</li>
            <li>未中拍：代拍服务费100元</li>
            <li>物流运输服务费100元</li>
          </ul>
          <div style={{ margin: '10px 0 12px', padding: '10px 12px', background: BG, borderRadius: 6, borderLeft: `3px solid ${GOLD}` }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: INK, marginBottom: 4 }}>最终到手价公式</div>
            <div style={{ fontSize: 13, color: INK3, lineHeight: 1.8 }}>
              最终金额 = 落槌价 + 日本消费税 + 拍卖行手续费 + 国际/国内运费 + 代拍服务费，按实时汇率结算
            </div>
          </div>
          <p style={S.p}>大陆及香港地区基础清关费用包含在物流运输服务费内。</p>
          <p style={S.p}>如需发往其他国家或地区，国际运费差价及当地关税由客户自行承担。</p>

          <div style={S.divider} />

          <h3 style={S.h2}>2. 付款、取消与退换</h3>
          <p style={S.p}>商品中拍后，客户需在规定时间内补齐尾款。</p>
          <p style={S.p}>尾款金额以实际成交价、页面显示金额、拍卖会账单及实际产生费用为准。</p>
          <p style={S.p}>本平台除固定服务费外，不额外加收隐藏费用。</p>
          <p style={S.p}>代拍商品中拍后，原则上不支持取消、退货、换货。</p>
          <p style={S.p}>以下情况一般不作为取消或退货理由：</p>
          <ul style={S.ul}>
            <li>觉得拍贵了</li>
            <li>临时不想要了</li>
            <li>尺寸不合适</li>
            <li>图片色差</li>
            <li>轻微瑕疵</li>
            <li>中古正常使用痕迹</li>
            <li>重量或尺寸轻微误差</li>
            <li>拍卖会页面已说明的问题</li>
          </ul>
          <p style={S.p}>如商品存在重大描述错误，本平台会协助客户与拍卖会、卖家或平台沟通，但最终处理结果以对方规则为准。</p>

          <div style={S.divider} />

          <h3 style={S.h2}>3. 最终说明</h3>
          <p style={S.p}>客户提交委托后，即视为已阅读、理解并接受本协议内容。</p>
          <p style={S.p}>云川中古会尽力协助客户确认商品信息、控制费用，并安排鉴定、改圈、运输等后续服务。</p>
          <p style={S.p}>本平台坚持公开透明，除明确说明的固定服务费外，不设置任何隐形消费。</p>
        </div>
      </div>
    </div>
  );
}
